export enum SettingActions {
  SET_LANGUAGE = 'SET_LANGUAGE',
  SET_SOUND = 'SET_SOUND',
  SET_SETTINGS = 'SET_SETTINGS',
  SET_MUSIC = 'SET_MUSIC',
  SET_THEME = 'SET_THEME',
  SET_FIRSTGAMER = 'SET_FIRSTGAMER',
  SET_SECONDGAMER = 'SET_SECONDGAMER',
}

export enum GameActions {
  SET_GAME = 'SET_GAME',
  SET_GAME_AGAIN = 'SET_GAME_AGAIN',
  SET_FIELD_SIZE = 'SET_FIELD_SIZE',
  SET_FIRST_WORD = 'SET_FIRST_WORD',
  SET_GAMER_TURN = 'SET_GAMER_TURN',
  ADD_WORD = 'ADD_WORD',
  ADD_POINTS = 'ADD_POINTS',
  SET_FIELD = 'SET_FIELD',
  SET_NEXT_TURN = 'NEXT_TURN',
  SET_START_GAME = 'SET_START_GAME',
  SET_STOP_GAME = 'SET_STOP_GAME',
  SET_WINNER = 'SET_WINNER',
  SET_PENALTY_POINTS = 'SET_PENALTY_POINTS',
}

export enum AlertActions {
  SET_NOTIFY = 'SET_NOTIFY',
  REMOVE_NOTIFY = 'REMOVE_NOTIFY',
}

export enum ModalActions {
  SET_MODAL = 'SET_MODAL',
  REMOVE_MODAL = 'REMOVE_MODAL',
  SET_UNIVERSAL_MODAL = 'SET_UNIVERSAL_MODAL',
  REMOVE_UNIVERSAL_MODAL = 'REMOVE_UNIVERSAL_MODAL',
}
